// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2nzL2","productName":"Table_productName__2Kba0"};